export const en = {
    "TRIGGER_LISTEN" : "Listening for triggers",
    "ASSIST_EMPTY_MSG" : "Agent AI is actively listening to your conversation and ready to assist automatically when triggered.",
    "MYBOT_TRIGGET_LISTEN" : "No active My Bot tasks presently",
    "MYBOT_EMTPY_MSG" : "To start a task on My Bot, go to the search tab and select the \"Run with agent inputs\" option for your desired task.",
    "PROACTIVE_MODE": "Proactive Mode",
    "SETTINGS": "Settings",
    "HELP_AND_SUPPORT": "Help & Support",
    "HELP": "Help",
    "FILE_NAME":"file Name",
    "LANGUAGE": "Language",
    "THEME": "Theme",
    "AUTOMATIC": "Automatic",
    "DARK": "Dark",
    "LIGHT": "Light",
    "THEME_DESC": "This will use your system default mode",
    "DOCUMENTATION": "Documentation",
    "DOC_DESC": "Check out our in-depth documentation articles.",
    "FAQ_U": "FAQ",
    "TAB_TEXT":"No tabs enabled! Please enable at least one tab",
    "FAQ_DESC": "Check out frequently asked questions about Agent AI.",
    "KORE_ACADEMY": "Kore Academy",
    "KORE_ACA_DESC": "Learn more about Agent AI by going through the academy courses.",
    "SEARCH": "Search",
    "MY_BOT": "My Bot",
    "ASSIST": "Assist",
    "TRANSCRIPT": "Transcript",
    "HISTORY" : "History",
    "STARTOVER" : "Start over",
    "RESTART_INPUTS" : "Restart with captured inputs",
    "ASKCUSTOMER" : "Ask Customer",
    "TELLCUSTOMER" : "Tell Customer",
    "WELCOME_MSG" : "Welcome Message",
    "SEND" : "Send",
    "SENT" : "Sent",
    "AWAITING" : "Awaiting Response  |  Type to continue",
    "OVERRIDE" : "Type to continue",
    "OVERRIDE_FILE" : "Attach File to continue",
    "ACCEPT_RESPONSE" : "Response Accepted",
    "AGENT_ENTERED" : "Agent Entered",
    "EXPECTED_FORMAT" : "Expected Format", 
    "INPUT_VALUES" : "Input Values", 
    "RESTART" : "Restart",
    "START_OVER" : "Start over",
    "RESTART_CAPTURE" : "Restart with captured inputs",
    "CANCEL" : "Cancel",
    "INTERRUPT_DIALOG" : "INTERRUPTED DIALOG TASK",
    "RUN" : "RUN",
    "RUN_AGENT" : "Run with Agent’s input",
    "STEP" : "Step",
    "DIALOG_TASK" : "Dialog Task",
    "FAQ" : "FAQ",
    "SNIPPET" : "Answers",
    "ARTICLE" : "Web Pages",
    "FILE" : "Files",
    "SUGGESTED" : "Suggested",
    "ALL_DIALOG" : "All Dialog Tasks",
    "DIALOG_TEXT" : "Dialog",
    "INTENT_IDENTIFIED" : "Customer utterance",
    "NOT_WHAT_LOOKING" : "Wrong Suggestion ?",
    "BOT" : "Bot", 
    "CUSTOMER" : "Customer",
    "YOU" : "You",
    "TERMINATE_CONV" : "Terminate Dialog Task",
    "TERMINATE_CONV_DESC" : "Are you sure you want to terminate the dialog task? Agent AI will no longer be able to make suggestions.",
    "YES_TERMINATE" : "Yes Terminate",
    "NO_CANCEL" : "No, Cancel",
    "OVERRIDE_CONTINUE" : "Continue with override mode",
    "SUMMARY_TEXT" : "Summary",
    "SUBMIT" : "Submit",
    "INTERRUPT_OCCURED" : "Interruption Occurred",
    "IDENTIFIED_INTENT" : "Identified intent",
    "INTERRUPT_DESC" : "Running this would terminate your on going Dialog Task.",
    "ACCEPT_RUN" : "Accept and Run",
    "RUN_LATER" : "Run Later",
    "KNOW_MORE" : "Know More",
    "MORE_TEXT" : "More",
    "LESS_TEXT" : "Less",
    "VIEW_MORE" : "View More",
    "VIEW_LESS" : "View Less",
    "SHOW_MORE_FAQ" : "Show more FAQs",
    "SHOW_LESS_FAQ" : "Show less FAQs",
    "SHOW_MORE_ARTICLE" : "Show more web pages",
    "SHOW_LESS_ARTICLE" : "Show less web pages",
    "SHOW_MORE_SNIPPET" : "Show more Answers",
    "SHOW_LESS_SNIPPET" : "Show less Answers",
    "SHOW_MORE_FILES" : "Show More Files",
    "PLAYBOOK": "Playbook",
    "SHOW_LESS_FILES" : "Show Less Files",
    "VIEW_ALL_DIALOG" : "View all Dialogs",
    "VIEW_FEW_DIALOG" : "View few Dialogs",
    "HELP_FULL" : "Helpful?",
    "THANKYOU" : "Thank you!",
    "EXPAND_MORE" : "Expand / More",
    "CLOSE_TEXT" : "Close",
    "STARTED" : "Started",
    "ENDED" : "ended",
    "VIEW_FULL_ARTICLE_2": "View full article",
    "VIEW_FULL_FILE_2": "View full file",
    "VIEW_FULL_ARTICLE" : "View web page",
    "VIEW_FULL_FILE" : "View file",
    "COPIED" : "Copied",
    "SENTI_ANALY" : "Sentiment Analysis",
    "WRONG_SUGGESTION" : "Wrong suggestions",
    "INCORRECT_INTENT" : "Incorrect intent",
    "ACCIDENTAL_CLICK" : "Accidental click",
    "TIME_TAKING" : "Time taking",
    "OTHER" : "Other",
    "PLAYBOOK_EMPTY_MSG" : "Select Playbook",
    "PLAYBOOK_EMPTY_DESC" : "Agent AI is unable to load the playbook due to all available playbooks being dynamic. Click 'Select Playbook' to access the playbook",
    "STAGE" : "Stage", 
    "PROCEED_TO_CLOSE" : "Proceed to close",
    "RECOMENDED_PLAYBOOK" : "RECOMMENDED PLAYBOOK",
    "PRIMARY_SCRIPTS" : "PRIMARY SCRIPTS",
    "DYNAMIC_SCRIPTS" : "DYNAMIC SCRIPTS",
    "RESUME" : "Resume",
    "ENABLE_CLOSE" : "Click on proceed to close button to enable Close Stage",
    "LIST_VIEW" : "List View",
    "TERMINATE" : "Terminate",
    "MINIMIZE" : "Minimize",
    "MAXIMIZE" : "Maximize",
    "NO_SEARCH_RESULT" : "No search result found",
    "SENTIMENT_AWAITING" : "Awaiting for sentiment",
    "POSITIVE" : "Pos",
    "NEGATIVE" : "Neg",
    "ASSOCIATED_WORK_NOTES": "Past Resolution Notes",
    "AGENT_JOINED_CONV": "Agent joined the conversation",
    "AUTOSCROLL_ASSIST" : "Auto-Scroll Content",
    "FILE_SIZE_MSG" : "File size must be within 25MB. Please retry.",
    "OVERRIDE_BTN" : "Override",
    "CHOOSE_FILE" : "Choose File",
    "SUMMARY_ERROR_TEXT" : "We're sorry, but there was a problem generating the summary for this conversation. Please create your own summary",
    "ASK_A_QUESTION": "Ask a question",
    "COPY" : "Copy",
    "TELL_US_MORE": "Tell us more…",
    "AUTO_SCROLL_TOOLTIP" :"Controls auto-scrolling of Assist Tab, My bot & Transcript Tab Contents",
    "TAP_SEARCH":"Tap for Search",
    "THANKS_FEEDBACK": "Thanks for your feedback",
    "SOMETHING_WRONG": "Something went wrong",
    "CLICK_ERROR_DETAILS": "Click for error details",
    "NO_ACTIVE_PLAYBOOK": "No active playbook",
    "REPHRASE_QUESTION": "Could you rephrase your question or ask something else?",
    "INTERNAL_INFO": "Internal information",
    "SOURCES": "Sources",
    "CONVERSATION_SUMMARY": "Conversation summary",
    "WAITING": "Waiting",
    "WIDGET_DISABLED": "Widget disabled",
    "AI_SETTINGS_DISABLED": "Agent AI settings configuration is disabled! Please reach out to the AI admin",
    "SERVER_CONNECTION_ERROR": "Error while connecting to the server",
    "VIEW": "View",
    "ATTACHMENT_INPUT": "Attachment input",
    "TYPE_SUMMARY": "Type summary",
    "BY":"by",
    GENERATE_SUMMARY: "Generate Summary",
    PREV_SUMMARIES: "Previously Generated Summaries",
    DIALOG_WORKFLOWS: "Dialog Workflows",
    SHOW_ALL_DIALOG: "Show all Dialog Task",
    SHOW_ALL_DIALOGS: "Show All Dialogs",
    CUSTOM_TAB: "Custom Tab",
    AGENT_INPUT: "Agent's Input",
    "CUSTOM_EMPTY_MSG" : "No active workflow presently",
    "CUSTOM_TAB_DESC" : "To start a workflow, execute one from the list present at the bottom of the screen.",
    "SUBMIT_OVERALL_FEEDBACK" : "Submit Overall Feedback",
    "FEEDBACK_POPUP_SUBTITLE" : "How satisfied are you with the widget & it\'s features?",
    "FEEDBACK_SATISFIED" : "Satisfied",
    "FEEDBACK_UNSATISFIED" : "Unsatisfied",
    "FEEDBACK_PROVIDE_REASONS" : "Provide Reasons",
    "FEEDBACK_TITLE" : "Feedback",
    "HINTS_WRAPPER_FIXED" : "aa-hints-wrapper-fixed",
    "NUDGES_WRAPPER_FIXED" : "aa-nudges-wrapper-fixed",
    "AGENTIC_THINKING" : "Thinking",
    "AGENTIC_AGENT_TITLE" : "Agent",
    "AGENTIC_COPILOT_MODE_TITLE" : "Agentic Copilot Mode",
    "AGENTIC_SENDING_MESSAGE" : "Sending...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot is actively listing to your conversation and ready to assist automatically",
    "AGENTIC_SEARCH_RESULTS" : "Agentic Results"
}
